import { render } from "./AnnouncementComponent.vue?vue&type=template&id=7b10593a&scoped=true&ts=true"
import script from "./AnnouncementComponent.vue?vue&type=script&lang=ts"
export * from "./AnnouncementComponent.vue?vue&type=script&lang=ts"

import "./AnnouncementComponent.vue?vue&type=style&index=0&id=7b10593a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.3.0_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b10593a"]])

export default __exports__